import { createColumnHelper } from '@tanstack/react-table';

import i18n from '@/core/i18n';
import { cn } from '@/lib/utils';

import {
  CsvImportUserError,
  UserErrorField,
} from '../../types/response/csv-import-users-error.response';

const columnHelper = createColumnHelper<CsvImportUserError>();

const EMAIL_ERROR_FIELDS = [UserErrorField.EMAIL, UserErrorField.DUPLICATE_EMAIL];

const ERROR_FIELD_LABELS: Record<UserErrorField, string> = {
  [UserErrorField.NAME]: 'authenticated.onboarding.team:importMembers.errors.invalidName',
  [UserErrorField.EMAIL]: 'authenticated.onboarding.team:importMembers.errors.invalidEmail',
  [UserErrorField.DUPLICATE_NAME]:
    'authenticated.onboarding.team:importMembers.errors.duplicateName',
  [UserErrorField.DUPLICATE_EMAIL]:
    'authenticated.onboarding.team:importMembers.errors.duplicateEmail',
};

export const getErrorMembersColumns = () => [
  columnHelper.accessor('name', {
    header: i18n.t('authenticated.onboarding.team:importMembers.fullName'),
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) {
        return (
          <span className="text-sm text-muted-foreground">
            {i18n.t('authenticated.onboarding.team:importMembers.emptyValue')}
          </span>
        );
      }
      return <span className="text-sm">{value}</span>;
    },
  }),
  columnHelper.accessor('email', {
    header: i18n.t('authenticated.onboarding.team:importMembers.email'),
    cell: ({ row, getValue }) => {
      const hasError = row.original.errorFields?.some(f => EMAIL_ERROR_FIELDS.includes(f));
      return <span className={cn('text-sm', hasError && 'text-destructive')}>{getValue()}</span>;
    },
  }),
  columnHelper.display({
    id: 'reason',
    header: i18n.t('authenticated.onboarding.team:importMembers.errors.reason'),
    cell: ({ row }) => {
      const errorFields = row.original.errorFields ?? [];
      if (errorFields.length === 0) return null;

      const reasonText = errorFields.map(field => i18n.t(ERROR_FIELD_LABELS[field])).join('; ');

      return <span className="text-sm text-destructive">{reasonText}</span>;
    },
  }),
];
